import { BaseModel } from '../_base/model.class';

import { IDetail, INote } from './balance.interface';


export class Balance extends BaseModel {
  constructor(
    private _id?: string,
    private number?: string,
    private property?: string,
    private status?: string,
    private invoiceNumber?: string,
    private invoiceFile?: string,
    private detail?: [IDetail],
    private detailCopy?: [IDetail],
    private discount?: number,
    private total?: number,
    private notes?: [INote],
    private createdBy?: string,
    private createdAt?: Date,
    private updatedBy?: string,
    private updatedAt?: Date,
  ) {
    super();

    this.setRequiredFields([
      '_id',
      'number',
      'property',
      'status',
      'invoiceNumber',
      'invoiceFile',
      'details',
      'discount',
      'total',
      'createdAt',
      'createdBy',
    ]);
  }
}
